export const eeffByCliente = (state) => (id) => {
	return state.eeff.find(ef => ef.cliente == Number(id))
}

export const ratingByClient = (state) => (id) => {
	return state.rating.find(r => {
		return r.cliente == Number(id)
	})
}
